module.exports = __webpack_public_path__ + "media/images/Haas-Logo-72cbc7ce12760df861794072e5520885.png";